export default {
  id: '',
  image: '',
  firstName: '',
  middleName: '',
  lastName: '',
  address: '',
  mobileNumber: '',
  telNumber: '',
  gender: '',
  maritalStatus: '',
  isDeleted: '',
  updatedBy: '',
};
